import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { WhatsAppModel } from '../models/WhatsAppModel';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import { faFaceSmile } from '@fortawesome/free-regular-svg-icons';
import { AutocompleteData } from '../models/Site';
import moment from 'moment';
import { set } from 'lodash';
import { TreeSelect } from 'antd';
import { CustomerModel, GetAppDictionaryListRequest } from '../models/superbit-api-models';
import { CustomerCardModel } from '../models/CustomerCardModel';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import { setReloadLeadTreatments } from '../app-context/leadsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import WebsocketMessages from './WebsocketMessages';
import _ from 'lodash';
import { setLoadTasks } from '../app-context/tasksSlice';
import { getEmojiList } from '../components/util';


interface Props {
    phoneNumber: any;
    fullName: string;
    ClosePopup?: Function;
    customerId?: string;
}

const dic = {
    "policies": "פוליסות",
    "sues": "תביעות",
    "offers": "הצעות",
    "leads": "לידים",
} as const;

type Filter = {
    searchText: string | undefined,
    fromDate: string | undefined,
    toDate: string | undefined,
    type: string | undefined,
    searchStatus: number
};

const ChatsMessages = (props: Props) => {

    const whatsAppModel: WhatsAppModel = new WhatsAppModel();
    const customerModel = new CustomerCardModel();

    const messagesDivRef = React.createRef<HTMLDivElement>();
    const hiddenFileInput = useRef<any>(null);

    const dispatch = useDispatch();

    const [userId, setUserId] = useState<string | null>();
    const [customerPhoneNumber, setCustomerPhoneNumber] = useState<string | null>(null);
    const [customerName, setCustomerName] = useState<string | null>(props.fullName);
    const [subMessages, setSubMessages] = useState<any[]>([]);
    const [curUserId, setCurUserId] = useState<string | null>(null);
    const [messageText, setMessageText] = useState<string>("");
    const [sendMessageLoading, setSendMessageLoading] = useState<boolean>(false);
    const [showEmoji2, setShowEmoji2] = useState<boolean>(false);
    const [soundFile, setsoundFile] = useState<boolean>(false);
    const [transferMessage, setTransferMessage] = useState<string | null>(null);
    const [forwardStatus, setForwardStatus] = useState<boolean>(false);
    const [forwardMessageRecipientName, setForwardMessageRecipientName] = useState<string | undefined>(undefined);
    const [recipientsAutoComplete, setRecipientsAutoComplete] = useState<Array<AutocompleteData>>([]);
    const [messageImg, setMessageImg] = useState<any | null>(null);
    const [messageImgSend, setMessageImgSend] = useState<number | null>(null);

    const [recipients, setRecipients] = useState<any[]>([]);
    const [forwardMessageRecipientPhoneNumber, setForwardMessageRecipientPhoneNumber] = useState<string | null>(null);
    const [forwardMessageRecipientUserId, setForwardMessageRecipientUserId] = useState<string | undefined>(undefined);
    const [transferType, setTransferType] = useState<number | null>(null);
    const [selectedMessage, setSelectedMessage] = useState<any | null>(null);
    const [currentUser, setCurrentUser] = useState<any | null>(null);
    const [lastMessage, setLastMessage] = useState<any>(null);

    const [treeTreatmentData, setTreeTreatmentData] = useState<any[]>([]);
    const [chooseRelation, setChooseRelation] = useState<any>(null);
    const [typeRelation, setTypeRelation] = useState<number | null>(null);

    const [loading, setLoading] = useState<boolean>(false);

    const [relationListType, setRelationListType] = useState<any[]>([]);

    const [editAble, setEditAble] = useState<boolean>(true);

    const emojiList: string[] = getEmojiList()

    const dayBefore = moment().subtract(1, 'days').subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss')

    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);

    const createTreatmentFrom = useSelector((state: RootState) => state.tasks.createTreatmentFrom);

    useEffect(() => {
        console.log('useEffect :>> ', props.phoneNumber);
        init();
    }, [props.phoneNumber])

    useEffect(() => {
        if (messagesDivRef.current) {
            messagesDivRef.current.scrollTop = messagesDivRef.current.scrollHeight;
        }
    }, [subMessages])

    useEffect(() => {
        sendMessage();

    }, [messageImgSend])

    const setRelationsData = (relationDataArg: any) => {
        const relationsData = relationDataArg;
        if (relationsData) {
            if (relationsData.leads && relationsData.leads.length > 0) {
                relationsData.leads.map((lead: any) => {
                    if (lead.offers && lead.offers.length > 0) {
                        let offers = [...lead.offers];
                        relationsData['offers'] = offers;
                    }
                })
            }
            const relationsDataKeys = Object.keys(relationsData);
            const relationsDataList: any[] = [];
            relationsDataKeys.forEach((k: string, idx: number) => {
                if (k !== 'policyRelated' && k !== 'leadRelated' && k !== 'sueRelated' && k !== 'open' && k !== 'elementaryInsurancePolicies' &&
                    //  (createTreatmentFrom.type !== 'lead' || k !== 'leads')) {
                    k !== 'leads') {
                    const relation = relationsData[k];
                    const relationData: any = {
                        title: dic[k as keyof typeof dic] ? dic[k as keyof typeof dic] : k,
                        value: idx,
                        key: idx,
                        selectable: false,
                        type: k,
                    }
                    if (relation && relation.length > 0) {
                        const children = relation.map((c: any, i: number) => {
                            console.log('c', c)
                            return {
                                title: k === 'policies' ? c.policyNumber : k === 'sues' ? c.sueNumber ? c.sueNumber + "-" + c.internalNumber : "0-" + c.internalNumber : k === "leads" ? c.identifier : c.offerIdentity,
                                value: c.id,
                                key: c.id,
                                selectable: true,
                                type: k
                            }
                        })
                        relationData["children"] = children;
                    }
                    relationsDataList.push(relationData);
                }
            })
            setTreeTreatmentData(relationsDataList);
        }

    }

    const fetchRelations = async () => {

        const storedRelations = sessionStorage.getItem(`treatmentsRelations-${props.customerId}`);
        if (storedRelations) {
            const relationsData = JSON.parse(storedRelations);
            console.log('setCustomerRef-storedRelations-relationDate-857', relationsData)
            setTreeTreatmentData(relationsData);
            setRelationsData(relationsData);
            return;
        }
        if (props.customerId) {
            const dataObject = await customerModel.treatmentsLoadRelations(props.customerId);
            sessionStorage.setItem(`treatmentsRelations-${props.customerId}`, JSON.stringify(dataObject));
            setTreeTreatmentData(dataObject);
            setRelationsData(dataObject);
        }

    }

    const getAppDictionaryRelationList = async () => {

        const relationTypesData = await customerModel.getRelationsTypes();
        console.log('relationTypesData', relationTypesData)
        const fixedRelationTypesKeysTypes: any[] = [];
        const relationTypesKeys = Object.keys(relationTypesData);
        relationTypesKeys.forEach((k: string) => {
            fixedRelationTypesKeysTypes.push({
                value: relationTypesData[k].id,
                label: relationTypesData[k].description
            })
        })
        setRelationListType(fixedRelationTypesKeysTypes);
        dispatch(setReloadLeadTreatments(true));


        console.log('fixedRelationTypesKeysTypes', fixedRelationTypesKeysTypes)

    }

    const init = async () => {
        const loggedUser = localStorage.getItem("loggedUser");
        if (loggedUser) {
            const currentUser: any = JSON.parse(loggedUser);
            setCurUserId(currentUser.id);
            setCurrentUser(currentUser);
            console.log('init', currentUser.id);
        }

        fetchRelations();
        openMessage();

        await getAppDictionaryRelationList()

        if (createTreatmentFrom && createTreatmentFrom.type && createTreatmentFrom.id) {
            if (createTreatmentFrom.type === 'policy') {

                setChooseRelation(createTreatmentFrom.id);
                setEditAble(false);
                setTypeRelation(2);
            }
            if(createTreatmentFrom.type === 'sue'){
                setChooseRelation(createTreatmentFrom.id);
                setEditAble(false);
                setTypeRelation(4);
            }
        }


    }

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup();
            setCustomerPhoneNumber(null);
        }
    }

    const openMessage = async () => {
        setTransferMessage("");
        setCustomerPhoneNumber(null);

        const loggedUser = localStorage.getItem("loggedUser");
        if (loggedUser) {
            setLoading(true);
            const currentUser: any = JSON.parse(loggedUser);
            let wData: any = null;
            wData = await whatsAppModel.whatsappGetMessage({
                CustomerPhoneNumber: props.phoneNumber
            });
            setMessageText("שלום, כאן " + JSON.parse(loggedUser).name + " " + getDepartment(currentUser.role) + " " + currentUser.branchName + ": ");
            setCustomerPhoneNumber(props.phoneNumber);
            // setCustomerName(dataObject.customerName);
            setUserId(currentUser.id);

            setSelectedMessage(wData.messages);

            if (wData.messages.length > 0) {
                const lastMessage = wData.messages[wData.messages.length - 1];
                setLastMessage(lastMessage);
            }


            console.log('list-whatsapp 1:', wData.messages);

            const subMessages = fixSubMessages(wData.messages);
            await setSubMessages(subMessages);
            setLoading(false);
        }
    }



    const onTextMessageChange = (e: any) => {
        setsoundFile(false);
        setTransferMessage("");
        setMessageText(e);
    }


    const addEmoji2 = (emoji: any) => {
        if (messageText === undefined)
            setMessageText(emoji);
        else {
            setMessageText(messageText + emoji);
        }
        setShowEmoji2(false);
    };


    const handleKeyPress = async (e: any) => {
        console.log(`Key pressed: ${e.key}`);  // Debug log

        if (e.key === 'Enter') {
            console.log(`Enter`);  // Debug log
            console.log("sendMessage 2");
            await sendMessage();
        }
    };

    const openForward = () => {

        setForwardStatus(true);
        setTransferMessage("");
    }

    const showEmojiList2 = () => {

        setShowEmoji2(true);
    }

    const handleOnFileClick = (event: any) => {
        setsoundFile(false);
        console.log('handleOnFileClick');
        if (hiddenFileInput && hiddenFileInput.current) {
            hiddenFileInput.current.click();
        }
    };

    const isSoundFile = (filename: string) => {
        const soundExtensions = [
            // Sound extensions
            '.mp3', '.wav', '.ogg', '.flac', '.aac', '.m4a',
            // Video extensions
            '.mp4', '.avi', '.mov', '.wmv', '.flv', '.mkv', '.webm'
        ];
        const extension = filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
        return soundExtensions.includes(`.${extension}`);
    };

    const handleOnFileChange = (event: any) => {
        const fileUploaded = event.target.files[0];
        if (isSoundFile(event.target.files.length > 0 && event.target.files[0].name)) {
            setsoundFile(true);
            return;
        }
        const fileSize: string = ((fileUploaded.size / 1024) / 1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = () => {
                //   setFile(file)
                //   setSize(file.size);
                //   setName(file.name)
                //   setImagePreview(reader.result)
                console.log(reader.result);
                setMessageImg({
                    FileName: (new Date().getTime()) + "_" + fileUploaded.name,
                    Content: reader.result
                });
                setMessageImgSend(Date.now());
            }
            reader.readAsDataURL(fileUploaded);
        }
        console.log('handleOnFileChange', fileUploaded);
        // handleFile(fileUploaded);
    };

    const sendMessage = async () => {

        if (!customerPhoneNumber) {
            return;
        }
        setSendMessageLoading(true);

        console.log("1");
        let data: any = null;
        const requestData: any = {}
        if (messageImg) {
            requestData.Files = [
                {
                    FileName: messageImg.FileName,
                    Content: messageImg.Content
                }
            ]
            console.log("2 - image");
        } else {
            if (messageText == '') return;
            requestData.text = messageText;
            console.log("2 - !image");
        }
        // if (userId) {
        //     requestData.UserId = userId;
        //     console.log("3 - userId");
        //     data = await whatsAppModel.whatsappSendMessageInner(requestData);
        //     setMessageText('');
        // } else {

        requestData.customerPhoneNumber = customerPhoneNumber;
        console.log("3 - !userId");
        data = await whatsAppModel.whatsAppSendMessage(requestData);
        const loggedUser = localStorage.getItem("loggedUser");
        if (loggedUser)
            setMessageText("שלום, כאן " + JSON.parse(loggedUser).name + " " + getDepartment(currentUser.role) + " " + currentUser.branchName + ": ");
        // }
        console.log("4");

        var old = subMessages.find(item => item.connectedUserId === userId);
        if (old != null) {

            if (messageImg) {
                old.hasFile = true;
                old.fileUrl = messageImg.FileName;
            }
            else {
                old.messageText = requestData.text;
            }
        }

        let wData = null;
        // if (userId) {
        //     wData = await whatsAppModel.whatsappGetMessage({
        //         UserId: userId
        //     })
        // } else {
        wData = await whatsAppModel.whatsappGetMessage({
            CustomerPhoneNumber: customerPhoneNumber
        })
        // }
        const _subMessages = fixSubMessages(wData.messages);
        await setSubMessages(_subMessages);

        if (messageImg) {
            setMessageImg(null);
        }
        setSendMessageLoading(false);
    }

    const fixSubMessages = (messages: any[]) => {
        const subMessages: any[] = [];
        messages.forEach((message: any) => {
            if (message.isTransferMessage && message.isTransferMessage == true) {
                const d = prepareDate(message.transferDate)
                message.date = d.date;
                message.time = d.time;
            }
            else {
                const d = prepareDate(message.createdDate ? message.createdDate : message.timestamp);
                message.date = d.date;
                message.time = d.time;
            }


            message.direction = 'left';
            // if (userId) {
            //     if (userId  message.senderUserId) {
            //         message.direction = 'left';
            //     } else {
            //         message.direction = 'right';
            //     }
            // } else {
            //     if (customerPhoneNumber === message.senderPhoneNumber) {
            //         message.direction = 'left';
            //     } else {
            //         message.direction = 'right';
            //     }
            // }
            if (message.senderUserId === undefined || message.receiverUserId === undefined) {
                if (message.senderUserId !== undefined) {
                    message.direction = 'right';
                }
                else {
                    message.direction = 'left';
                }
            }
            else {
                if (message.senderUserId === curUserId) {
                    message.direction = 'right';
                }
                else {
                    message.direction = 'left';
                }
            }


            message.hasImage = false;
            message.hasFile = false;
            message.messageText = message.text;
            if (message.text && message.text.indexOf('image;') > -1) {
                message.hasImage = true;
                // m.imageName = 'image';
                message.imageUrl = message.text.replace('image;', '');
                message.messageText = '';
            }
            if (message.text && message.text.indexOf('document;') > -1) {
                message.hasFile = true;
                message.fileUrl = message.text.replace('document;', '');
                message.fileName = message.fileUrl.substring(message.fileUrl.lastIndexOf('/') + 1);
                message.messageText = '';
            }

            subMessages.push(message);
        });
        return subMessages;
    }

    const prepareDate = (dateStr: string) => {
        let date = new Date(dateStr);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const dateString = `${day}/${month}/${year}`;

        const hours = date.getHours();
        const minutes = date.getMinutes();
        const timeString = `${hours}:${minutes}`;

        return {
            date: dateString,
            time: timeString
        }
    }

    const getDepartment = (role: number) => {
        switch (role) {
            case 0: return "- מנהל";
            case 6: return "ממחלקת מכירות";
            case 7: return "מנהל/ת מחלקת מכירות";
            case 8: return "ממחלקת חיתום";
            case 9: return "ממחלקת חידושים";
            case 10: return "מנהל/ת מחלקה";
            case 11: return "- שירות לקוחות";
            case 12: return "מנהל/ת ביטוח חיים";
        }

    }


    const getRecipientsList = async () => {
        const recipients_list = await whatsAppModel.customerCardGetUsers();
        setRecipients(recipients_list.filter((r: any) => r.phoneNumber !== null || r.whatsAppNumber !== null));
    }

    const onForwardRecipientChange = (event: any) => {
        const filteredRcipients = recipients.filter((r: any) => r.fullName !== null && r.fullName.indexOf(event.currentTarget.value) > -1);
        setForwardMessageRecipientName(event.currentTarget.value);
        setRecipientsAutoComplete(filteredRcipients.map((r: any) => {
            const online = r.lastLogIn > r.lastLogOut && moment(r.lastLogIn).isAfter(moment().startOf('day'));
            return {
                label: r.fullName,
                val: r.id,
                type: online ? 'greem' : 'red',
                online: online
            }
        }))
    }


    const onForwardRecipientSelect = (fullName: string) => {

        if (fullName !== "") {
            const recipient = recipients.find((r: any) => r.fullName === fullName);
            setForwardMessageRecipientName(recipient.fullName);
            setForwardMessageRecipientPhoneNumber(recipient.phoneNumber);
            setForwardMessageRecipientUserId(recipient.id);
        }
        else {
            setForwardMessageRecipientName("");
            setForwardMessageRecipientPhoneNumber("");
            setForwardMessageRecipientUserId("");
        }

    }

    const onTransferTypeSelect = (e: any) => {

        setTransferType(parseInt(e.currentTarget.value));
        setTransferMessage("");
    }

    const forwardMessage = () => {

        whatsAppModel.whatsappTransfer({
            TransferTo: forwardMessageRecipientUserId,
            TransferFromUserId: userId,
            CustomerPhoneNumber: customerPhoneNumber,
            transferType: transferType === null ? 0 : transferType
        }).then((res) => {
            setForwardStatus(false);
            setTransferMessage("הודעה הועברה ל" + forwardMessageRecipientName);
        })

    }


    const onClear = () => {
        setChooseRelation('');
        setTypeRelation(null);
    }

    const onChangeRelations = (v: any) => {
        let selectedItem = null;
        // need to check whiche branch in tree data treeTreatmentData  is selected if is policies or leads or sues
        for (let i = 0; i < treeTreatmentData.length; i++) {
            let Item = treeTreatmentData[i].children && treeTreatmentData[i].children.length > 0 && treeTreatmentData[i].children.find((a: any) => a.key === v);
            if (Item) {
                console.log('Item', Item)
                selectedItem = Item;
            }
        }
        if (selectedItem) {
            switch (selectedItem.type) {
                case 'policies':
                    setChooseRelation(v);
                    let relationTypeNumber = relationListType.find((r: any) => r.label === 'Policy');
                    setTypeRelation(relationTypeNumber.value);
                    break;
                case 'leads':
                    setChooseRelation(v);
                    let relationTypeNumber2 = relationListType.find((r: any) => r.label === 'Lead');
                    setTypeRelation(relationTypeNumber2.value);
                    break;
                case 'sues':
                    setChooseRelation(v);
                    let relationTypeNumber3 = relationListType.find((r: any) => r.label == 'Sue');
                    setTypeRelation(relationTypeNumber3.value);
                    break;
                case 'offers':
                    setChooseRelation(v);
                    let relationTypeNumber4 = relationListType.find((r: any) => r.label === 'Offer');
                    setTypeRelation(relationTypeNumber4.value);
                    break;
                default:
            }
        }
    }

    const createTreatment = () => {
        if (props.customerId && customerPhoneNumber) {
            if (typeRelation && typeRelation >= 0 && chooseRelation) {
                let res = whatsAppModel.whatsappSendFollowUpMessage({
                    id: props.customerId,
                    type: typeRelation,
                    relatedId: chooseRelation,
                });
                console.log('create Treatment typeRelation >= 0 :>> ', res);
            } else {
                let res = whatsAppModel.whatsappSendFollowUpMessage({
                    id: props.customerId,
                });
                console.log('create Treatment :>> ', res);
            }
            closePopup();


            if (leadIdForTreatment && leadIdForTreatment.length > 0) {

                setTimeout(() => {
                    dispatch(setReloadLeadTreatments(true));
                }, 3000);
            } else {
                setTimeout(() => {
                    dispatch(setLoadTasks(true));
                }, 3000);
            }
        }
    }

    const onNewMessageArrived = async (messageType: string, message: any) => {
        console.log('onNewMessageArrived', messageType, message);

        if (props.phoneNumber && props.phoneNumber.length > 0 && props.phoneNumber === message.CustomerPhoneNumber.replace(/^(\+?972)/, '0')
            && message.SenderPhoneNumber.replace(/^(\+?972)/, '0') === props.phoneNumber) {

            console.log('list-whatsapp 2:', message);
            let newMessageWhatsApp: any = {}
            // copy message to newMessageWhatsApp as any and not as WhatsAppMessage
            newMessageWhatsApp = {
                ...Object.fromEntries(
                    Object.entries(message).map(([key, value]) => [key.toLowerCase(), value])
                ),
            }

            console.log('newMessageWhatsApp', newMessageWhatsApp)

            const newSubMessages = fixSubMessages([newMessageWhatsApp]);
            await setSubMessages((prevMessages) => [...prevMessages, ...newSubMessages]);

        }

        // await setSubMessages(subMessages);
    }

    const downloadImage = (message: any) => {
        let documentUrl = '';
        if (message.imageUrl && (message.imageUrl.indexOf('https://') > -1 || message.imageUrl.indexOf('https://') > -1)) {
            documentUrl = message.imageUrl;
        } else {
            // documentUrl = message.text.split('image;')[1];
        }
        console.log('documentUrl downloadDocument', message.hasImage, message.imageUrl)
        // let urlLink = apiUrl + imageUrl.split('co.il')[1]

        if (message && message.imageUrl && message.imageUrl.length > 0) {
            const fileUrl = `${message.imageUrl}`;
            const anchor = document.createElement('a');
            anchor.href = `${message.imageUrl}`;
            anchor.download = 'filename.png'; // Set the filename you want
            anchor.target = '_blank';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const downloadDocument = (message: any) => {

        console.log('documentUrl downloadDocument', message)
        // let urlLink = apiUrl + imageUrl.split('co.il')[1]

        if (message && message.fileUrl && message.fileUrl.length > 0) {
            const fileUrl = `${message.fileUrl}`;
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.download = 'filename.pdf'; // Set the filename you want
            anchor.target = '_blank';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const checkPhoneValidation = (phoneNumber: string | null) => {
        if (phoneNumber === null || phoneNumber.length < 10) {
            return false;
        }
        // const phoneRegex = /^0[0-9]{9}$/; // Matches Israeli phone numbers starting with 0 and followed by 9 digits
        const phoneRegex = /^(05)\d{8}$/;
        return phoneRegex.test(phoneNumber);
    }

    return (
        <>
            <WebsocketMessages updateMessages={onNewMessageArrived} />
            {props.phoneNumber && <div className={`popup-wrapper add-treatment-popup ${10}`} style={{zIndex: 1000}}>
                <section className="popup-window rtl" style={{ minHeight: '500px', width: '600px' }}>
                    <div className="close-icon pointer" onClick={() => closePopup()}></div>
                    <div className="email-content" style={{ maxHeight: '90vh' }}>
                        <div className="top-row">
                            <div className="title whatsapptitle">
                                <div className='rightFloat'>{props.fullName}</div>
                                <div className='leftFloat'>{customerPhoneNumber ? customerPhoneNumber.replace(/^972/, "0") : ""}</div>

                            </div>
                            {/* <div>
                            <div className={`icon star${props.selectedMessage.star ? ' selected' : ''}`}></div>
                        </div> */}
                        </div>
                        <div ref={messagesDivRef} className='vert-scrolling messages-list' style={{ maxHeight: '650px', overflowY: 'auto' }}>
                            {loading == false && lastMessage != null && lastMessage.createdDate > dayBefore
                                && subMessages.map((message: any, i: number) => {
                                    return (
                                        <div className={`message-row whatsapp-message-row ${message.direction} `} key={i}>
                                            <div className={` whatsapp-message ${message.direction}`}>
                                                {
                                                    message.hasImage ? <div className="whatsapp-message-text">
                                                        <img src={message.imageUrl} className='message-image' />
                                                    </div> : <></>
                                                }
                                                {
                                                    message.hasFile ? <div className="whatsapp-message-text">
                                                        <a href={message.fileUrl} className='message-image'>
                                                            <div className="icon document-icon"></div>
                                                            <div>{message.fileName}</div></a>
                                                    </div> : <></>
                                                }
                                                <div className="whatsapp-message-text">
                                                    <div>{message.senderUser != null ? (message.senderUserId == curUserId ? "אני" : message.senderUser.fullName) : message.customerName}:</div>
                                                    <div className={`${message.isTransfer && message.isTransfer == 1 ? "transferMessge" : ""}`}>{message.messageText}</div>
                                                </div>

                                                <div className="message-date">
                                                    <div>
                                                        {message.date}
                                                    </div>
                                                    <div>&nbsp;</div>
                                                    <div>
                                                        {message.time}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                )}
                            {loading == false && ((lastMessage != null && lastMessage.createdDate < dayBefore) || subMessages.length == 0) &&
                                <div className={`message-row whatsapp-message-row right `} key={1} style={{ display: 'block' }}>
                                    <div className={`parameter-item`} style={{ width: '40%' }}>
                                        <div className="field">
                                            <div className="title">
                                                שייך ל
                                            </div>
                                            <div className="value">
                                                <TreeSelect
                                                    treeLine
                                                    placeholder='שייך ל'
                                                    showSearch
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    dropdownStyle={{
                                                        maxHeight: 400,
                                                        overflow: 'auto',
                                                    }}
                                                    allowClear
                                                    onChange={(v: any) => onChangeRelations(v)}
                                                    treeData={treeTreatmentData}
                                                    value={chooseRelation}
                                                    disabled={editAble == false}
                                                />

                                            </div>

                                        </div>
                                    </div>

                                    {checkPhoneValidation(customerPhoneNumber) ?
                                        <div className={` whatsapp-message right`} style={{ width: '36%' }}>
                                            <button className="btn-new-msg" onClick={() => createTreatment()}>התחל שיחה עם לקוח ← </button>
                                        </div>
                                        :
                                        <div>
                                            <div className={` whatsapp-message right`} style={{ width: '36%' }}>
                                                <p>יש לעדכן טלפון תקין בכרטיס הלקוח</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }

                            {loading == true &&
                                <PleaseWaitLayer />
                            }

                        </div>
                        <div className="message-footer whatsapp-message-footer">
                            {loading == false && lastMessage != null && lastMessage.createdDate > dayBefore
                                && subMessages.length > 0 &&
                                <div className="filter-row">
                                    <div className="filter-input send-message">
                                        {/*<input type="text" multiple placeholder="כתוב הודעה..." onKeyDown={handleKeyPress} value={messageText} onChange={(e: any) => onTextMessageChange(e.target.value)} />*/}
                                        <textarea placeholder="כתוב הודעה..." rows={1} className='textArea' value={messageText} onKeyDown={handleKeyPress} onChange={(e: any) => onTextMessageChange(e.target.value)}></textarea>

                                        <div className='share' onClick={openForward}><FontAwesomeIcon icon={faShare} /></div>
                                        <div className='share' onClick={showEmojiList2}><FontAwesomeIcon icon={faFaceSmile} /></div>
                                        <div className="icon paperclip pointer" onClick={handleOnFileClick}></div>
                                        <input type="file" accept="image/png, image/gif, image/jpeg, application/pdf, application/msword,.doc,.docx" hidden ref={hiddenFileInput} onChange={handleOnFileChange} />
                                        <div className="icon email" onClick={sendMessage}></div>
                                        <img src={require("../assets/images/loading.gif")} className={sendMessageLoading ? "loadingGif" : "hide"} />
                                        <div className={showEmoji2 ? "emoji-container" : "hide"}>
                                             {emojiList.map((emoji: string, index: number) => (
                                                                <span key={index} className="emoji-button" onClick={() => addEmoji2(emoji)}>{emoji}</span>
                                                            ))}
                                            
                                            {/* Add more emojis as needed */}
                                        </div>

                                    </div>

                                </div>
                            }
                            <div className='sounddddd error-message'>{soundFile ? "המערכת לא תומכת בקבצי סאונד" : ""}</div>
                            <div className='error-message'>{transferMessage}</div>
                            <div className={forwardStatus ? "filter-row" : "hide"}>

                                <div>


                                    <input type='text' placeholder='שם'
                                        list="recipientsAutoComplete_list"
                                        value={forwardMessageRecipientName}
                                        onChange={(e: any) => onForwardRecipientChange(e)}
                                        onBlur={(e: any) => onForwardRecipientSelect(e.currentTarget.value)}
                                    />
                                    <datalist id="recipientsAutoComplete_list">
                                        {recipientsAutoComplete.map((o, i) => <option key={i} id={o.val} value={o.label}>{ }</option>)}
                                    </datalist>
                                </div>
                                <div>
                                    <select onChange={onTransferTypeSelect}>
                                        <option value={0}>הכל</option>
                                        <option value={1}>שבוע</option>
                                        <option value={2}>חודש</option>
                                        <option value={3}>שנה</option>
                                    </select>
                                </div>
                                <button type="button" className="new-email button blue flex-centered flex-justify-center pointer" onClick={() => forwardMessage()}>
                                    העברה
                                </button>

                            </div>
                        </div>
                    </div>
                </section>
            </div>}
        </>
    )
}

export default ChatsMessages